import View from '../../view.js';

class PinpadQueriesNew extends View {
  beforeFilter() {
    this.el = '#pinpad-queries-container';
  }

  get dom() {
    return {
      SCHEDULE_SELECT2: '#pinpad_query_scheduled_weekdays',
      EVERY_DAY_CHECKBOX: '#everyday',
    };
  }

  get events() {
    return {
      'change #everyday': 'everydayToogle',
      'click #cancel-pinpad-schedule': 'confirmCancel',
      'change #pinpad_query_scheduled_weekdays': 'allDaysSelected',
    };
  }

  confirmCancel(e) {
    let confirmationModal,
      msg =
        'Canceling a schedule will only affect future jobs. Running jobs will finish. <br />Do you want to proceed?';

    e.preventDefault();
    confirmationModal = new IO.Views.ConfirmationModal({
      el: '#confirmation-modal',
      closable: false,
    });

    confirmationModal.show(msg, (awnser) => {
      if (awnser) {
        $.rails.handleMethod(
          this.$('#cancel-pinpad-schedule').clone().data('method', 'delete'),
        );
      }
    });
  }

  everydayToogle(e) {
    const checked = $(e.target).is(':checked');
    const select2 = $(this.dom.SCHEDULE_SELECT2);

    select2.val(checked ? [0, 1, 2, 3, 4, 5, 6] : []).trigger('change');
  }

  allDaysSelected(e) {
    const qtySelectedDays = ($(e.target).val() || []).length;
    const checkbox = $(this.dom.EVERY_DAY_CHECKBOX);
    const allDaysLength = 7;

    if (qtySelectedDays === allDaysLength && !checkbox.is(':checked')) {
      checkbox.prop('checked', true);
    } else if (qtySelectedDays !== allDaysLength && checkbox.is(':checked')) {
      checkbox.prop('checked', false);
    }
  }
}

module.exports = PinpadQueriesNew;
